import { Theme, alpha } from '@mui/material/styles';

export const cardModalBuyTokensStyles = (theme: Theme, isDark: boolean) => ({
  countdownText: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    mx: 0,
    width: '100%',
    pl: 3,
    pr: 5.5
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '215px',
      height: 'auto'
    }
  },
  svgIcon: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '220px'
    },
    [theme.breakpoints.down('sm')]: {
      width: '200px'
    },
    '&:hover': {
      cursor: 'pointer',
      transform: 'translate(10px, 10px)',
      textDecoration: 'none',
      '& $svgIcon': {
        transform: 'translateY(-10px)'
      },
      '& path': {
        cursor: 'pointer',
        fill: '#fff'
      },
      '& .MuiTypography-root': {
        fontVariationSettings: "'wght' 400",
        textDecoration: 'none',
        cursor: 'pointer'
      }
    }
  },
  title: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 500",
    pb: 0.5,
    color: isDark ? theme.palette.text.primary : theme.palette.primary.main
  },
  foreignObject: { width: '100%', height: '100%' },
  linkText: {
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
    fontVariationSettings: "'wght' 400"
  },
  avatar: { width: 48, height: 48, mr: 1.25, mb: 2 },
  chip: {
    mt: 1.5,
    borderRadius: '10px',
    color: 'white',
    backgroundColor: alpha(theme.palette.primary.main, 0.76)
  },
  chipUsa: {
    mt: 1.5,
    ml: 1,
    borderRadius: '10px',
    color: 'white',
    backgroundColor: isDark ? '#8b95a730' : 'rgb(80 80 80 / 23%)',
    '& .MuiChip-avatar': {
      width: '18px',
      height: '18px'
    }
  }
});
